import { useGetMeQuery } from '@/api/userApiSlice';
import { ReactNode, createContext, useEffect, useState } from 'react';
import {
	clearJustLoggedIn,
	selectMyInfo,
	setMyInfo,
} from '../pages/auth/authSlice';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@/store';
import ChangeUnitModal from '@/common/components/modal/ChangeUnitModal';

const UserContext = createContext<any>(null);

const UserProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
	const [changeUnitOpen, setChangeUnitOpen] = useState(false);
	const userInfo = useSelector(selectMyInfo);
	const dispatch = useDispatch();
	const justLoggedIn = useSelector(
		(state: RootState) => state.auth.justLoggedIn
	);

	const {
		data: getMeResponse,
		isLoading,
		isSuccess,
		refetch: userInfoRefetch,
	} = useGetMeQuery(null, { refetchOnMountOrArgChange: true });
	console.log(getMeResponse);
	useEffect(() => {
		if (!isLoading && getMeResponse) {
			dispatch(setMyInfo(getMeResponse.data));
			if (justLoggedIn) {
				if (
					getMeResponse.data.branchList &&
					getMeResponse.data.branchList.length > 1
				)
					setChangeUnitOpen(true);

				dispatch(clearJustLoggedIn());
			}

			// setUserInfo({
			// 	nickname: '113',
			// 	role: 'ROLE_SUPPORTING_STAFF',
			// });
		}
	}, [isLoading, getMeResponse]);

	return (
		<UserContext.Provider
			value={{ userInfo, isLoading, isSuccess, userInfoRefetch }}
		>
			{children}
			<ChangeUnitModal
				changeUnitOpen={changeUnitOpen}
				setChangeUnitOpen={setChangeUnitOpen}
			/>
		</UserContext.Provider>
	);
};

export { UserContext, UserProvider };
